import React from 'react'

import { Section, Properties, Activation, Empty, Text, InfosBar, SubscriptionDeadline, Version } from 'components';
import { Container, Button, Segment, Label } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import {
  SectionDevice,
  SectionAccount
} from './sections';

import { ModalOptions, ModalEditDevice } from 'modals';

import { EnumChannel } from 'enums';

import { Typeof } from 'utils';
import { API } from 'services';

import moment from 'moment';

class PaneInformations extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      showEditModal: false,
      showDissociateModal: false,
      showRevokeModal: false
    };

    this.toggleDissociateModal = this.toggleDissociateModal.bind(this);
    this.handleCloseDissociateModal = this.handleCloseDissociateModal.bind(this);

    this.toggleEditModal = this.toggleEditModal.bind(this);
    this.handleCloseEditModal = this.handleCloseEditModal.bind(this);

    this.toggleRevokeModal = this.toggleRevokeModal.bind(this);
    this.handleCloseRevokeModal = this.handleCloseRevokeModal.bind(this);
  }

  toggleEditModal() {

    //Show modal
    this.setState({
      showEditModal: !this.state.showEditModal
    });
  }

  handleCloseEditModal(edit) {

    if (Typeof.object(edit)) {

      this.props.onModelChange(edit);
    }

    //Hide modal
    this.toggleEditModal();
  }

  toggleDissociateModal() {

    //Show modal
    this.setState({
      showDissociateModal: !this.state.showDissociateModal
    });
  }

  handleCloseDissociateModal(result, setProcessing) {

    if (result === ModalOptions.OPTION_YES) {

      setProcessing(result);

      API.delete(`/clinics/${this.props.device.clinic.id}/devices/${this.props.device.id}`)
        .then(() => {

          console.log(this.props);

          this.props.onDissociate();

        }).finally(this.toggleDissociateModal);

    } else {

      this.toggleDissociateModal();
    }
  }

  toggleRevokeModal() {

    //Show modal
    this.setState({
      showRevokeModal: !this.state.showRevokeModal
    });

  }

  handleCloseRevokeModal(result, setProcessing) {

    if (result === ModalOptions.OPTION_YES) {

      setProcessing(result);

      API.delete(`/devices/${this.props.device.id}/revoke`)
        .then((response) => {

          this.props.device.activated = false;
          this.props.device.activation_code = response.data.code;

          this.toggleRevokeModal();
        });

    } else {

      this.toggleRevokeModal();
    }
  }

  render() {

    const { device } = this.props;

    let hasClinic = Typeof.object(device.clinic);

    let deviceProperties = [
      {
        name: 'Numéro de produit',
        value: device.id
      },
      {
        name: `Date de livraison`,
        value: Typeof.string(device.delivery_date) ? moment(device.delivery_date).format('[Le] DD/MM/YYYY') : <Empty />
      },
      {
        name: () => {
          return (
            <React.Fragment>
              Activation

              {/* Revoke link */}
              {device.activated &&
                <Link className="activation-revoke" onClick={this.toggleRevokeModal}>(Révoquer)</Link>
              }
            </React.Fragment>
          )
        },
        value: () => {
          return (
            <Activation code={device.activation_code} activated={device.activated} />
          )
        }
      },
      {
        name: 'Canaux de distribution de micrologiciel',
        value: () => {

          if(device.channels.length > 0) {

            return (
              <div>
                {device.channels.map((channel) => {

                  return (
                    <Label color={EnumChannel.color(channel)}>{EnumChannel.name(channel)}</Label>
                  );
                })}
              </div>
            );

          } else {
            return <Empty />
          }

        }
      },
      {
        name: "Date limite d'abonnement",
        value: () => {

          if(Typeof.string(device.subscription_deadline)) {
            return <SubscriptionDeadline date={device.subscription_deadline} />
          }

          return <Empty />
        }
      }
    ];

    let deviceSynchronizedProperties = [
      {
        name: "Version de l'application",
        value: Typeof.string(device.app_version) ? <Version version={device.app_version} current={this.props.appStoreVersion}/> : <Empty />
      },
      {
        name: "Installée le",
        value: Typeof.string(device.update_date) ? moment(device.update_date).format('DD/MM/YYYY [à] HH:mm:ss') : <Empty />
      },
      {
        name: "Version iOS",
        value: Typeof.string(device.ios_version) ? <Text style={{"mono" : true}}>{device.ios_version}</Text> : <Empty />
      },
      {
        name: "Version de l'algorithme",
        value: Typeof.string(device.algo_version) ? <Text style={{"mono" : true}}>{device.algo_version}</Text> : <Empty />
      }
    ];

    return (
      <React.Fragment>

        {/* Informations */}
        <Container>

          <Section title="Informations" actions={[
            <Button icon="edit" circular onClick={this.toggleEditModal} key={0} />,
            hasClinic ? <Button icon="unlink" circular color="red" onClick={this.toggleDissociateModal} key={1} /> : null
          ]}>

            <Properties properties={deviceProperties} />

          </Section>

          {/* <Divider horizontal>
            <Header as='h4'>
              <Icon name='sync alternate' />
              Informations synchronisées
            </Header>
          </Divider> */}

          {/* Synchronization */}
          <Segment>
            <Properties properties={deviceSynchronizedProperties} />

            <InfosBar mode="row">
              <span>{Typeof.string(device.last_sync) ? moment(device.last_sync).format('[Synchronisé le] DD/MM/YYYY [à] HH:mm:ss') : "Aucune synchronisation"}</span>
            </InfosBar>
          </Segment>

        </Container>

        <Container>

          {/* iPad */}
          <SectionDevice device={device} />

        </Container>

        <Container>

          {/* Apple ID */}
          <SectionAccount device={device} />

        </Container>


        {/* Device edit modal */}
        {this.state.showEditModal &&
          <ModalEditDevice onClose={this.handleCloseEditModal} device={device} />
        }

        {/* Device dissociates warning modal */}
        {hasClinic && this.state.showDissociateModal &&
          <ModalOptions onClose={this.handleCloseDissociateModal} icon="unlink" title="Dissocier" message={<span>Vous êtes sur le point de dissocier cette valise du client <b>{device.clinic.name}</b>.<br /><br />Voulez vous continuer ?</span>} options={ModalOptions.OPTIONS_YESCANCEL} />
        }

        {/* Device revoke warning modal */}
        {this.state.showRevokeModal &&
          <ModalOptions onClose={this.handleCloseRevokeModal} icon="trash alternate" title="Révoquer" message={<span>Vous êtes sur le point de révoquer l'activation de cette valise.<br /><br />Voulez vous continuer ?</span>} options={ModalOptions.OPTIONS_YESCANCEL} />
        }

      </React.Fragment>
    );
  }
}

export default PaneInformations;
